import {
  stopImpersonation,
  useAuthContext,
  useAuthDetails,
} from "@/context/auth-context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserSecret,
  faXmark,
} from "@nnr/fontawesome-sharp-light/icons/sharp/light";
import { Button } from "./ui/button";

/**
 * Banner that appears when an admin is impersonating another user.
 * Shows who is being impersonated and provides a button to stop impersonation.
 */
export function ImpersonationBanner() {
  const authDetails = useAuthDetails();
  const { isImpersonating } = useAuthContext();

  if (!isImpersonating || !authDetails) {
    return null;
  }

  return (
    <div className="bg-accent-9 text-background flex flex-row items-center justify-center gap-4 px-6 py-1">
      <div className="flex flex-row items-center gap-2 text-xs">
        <FontAwesomeIcon icon={faUserSecret} />
        <div>Impersonating</div>
        <div className="font-semibold">
          {authDetails.name} ({authDetails.email})
        </div>
      </div>

      <Button
        onClick={stopImpersonation}
        variant="default"
        size="sm"
        className="h-6"
      >
        <FontAwesomeIcon icon={faXmark} />
        Stop
      </Button>
    </div>
  );
}
